import React from 'react';

import PageInner from '@/components/Base/PageInner';
import PageSidebar from '@/components/Base/PageSidebar';
import { Main } from '@/components/Base/PageStyles';
import ProductsList from '@/components/Pages/Home/ProductsList';

function HomePageContent() {
  return (
    <PageInner>
      <Main>
        <ProductsList />
      </Main>

      <PageSidebar />
    </PageInner>
  );
}

export default HomePageContent;
